import generateDate from "../helpers/generateDate.js";
import mainMethod from "./mainMethod.js";
let currentSelf = null;
const removeHover = () => {
  var _a;
  if (!currentSelf) return;
  const daysEl = (_a = currentSelf.HTMLElement) == null ? void 0 : _a.querySelectorAll(`.${currentSelf.CSSClasses.dayBtnHover}`);
  if (daysEl) daysEl.forEach((d) => d.classList.remove(currentSelf.CSSClasses.dayBtnHover));
};
const addHover = (day) => {
  var _a;
  if (!currentSelf || !currentSelf.selectedDates) return;
  const date = generateDate(day);
  if (currentSelf.rangeDisabled && currentSelf.rangeDisabled.includes(date)) return;
  const dayEls = (_a = currentSelf.HTMLElement) == null ? void 0 : _a.querySelectorAll(`[data-calendar-day="${date}"]`);
  dayEls == null ? void 0 : dayEls.forEach((dayEl) => {
    dayEl.classList.add(currentSelf.CSSClasses.dayBtnHover);
  });
};
const hoverDaysEvent = (e) => {
  if (!e.target || !currentSelf || !currentSelf.selectedDates) return;
  if (!e.target.closest(`.${currentSelf.CSSClasses.days}`)) {
    removeHover();
    return;
  }
  const date = e.target.dataset.calendarDay;
  if (!date) return;
  removeHover();
  const startDate = new Date(
    (/* @__PURE__ */ new Date(`${currentSelf.selectedDates[0]}T00:00:00`)).getFullYear(),
    (/* @__PURE__ */ new Date(`${currentSelf.selectedDates[0]}T00:00:00`)).getMonth(),
    (/* @__PURE__ */ new Date(`${currentSelf.selectedDates[0]}T00:00:00`)).getDate()
  );
  const endDate = new Date(
    (/* @__PURE__ */ new Date(`${date}T00:00:00`)).getFullYear(),
    (/* @__PURE__ */ new Date(`${date}T00:00:00`)).getMonth(),
    (/* @__PURE__ */ new Date(`${date}T00:00:00`)).getDate()
  );
  if (endDate > startDate) {
    for (let i = startDate; i <= endDate; i.setDate(i.getDate() + 1)) {
      addHover(i);
    }
  } else {
    for (let i = startDate; i >= endDate; i.setDate(i.getDate() - 1)) {
      addHover(i);
    }
  }
};
const cancelSelectionDays = (e) => {
  if (!currentSelf || e.key !== "Escape") return;
  currentSelf.selectedDates = [];
  currentSelf.HTMLElement.removeEventListener("mousemove", hoverDaysEvent);
  document.removeEventListener("keydown", cancelSelectionDays);
  mainMethod(currentSelf);
};
const setDisabledDates = () => {
  var _a;
  if (!currentSelf || !((_a = currentSelf.selectedDates) == null ? void 0 : _a[0]) || !currentSelf.rangeDisabled || currentSelf.rangeDisabled.length < 2) return;
  const selectedDate = /* @__PURE__ */ new Date(`${currentSelf.selectedDates[0]}T00:00:00`);
  let startDate = null;
  let endDate = null;
  for (let index = 0; index < currentSelf.rangeDisabled.length; index++) {
    const disabledDate = /* @__PURE__ */ new Date(`${currentSelf.rangeDisabled[index]}T00:00:00`);
    if (selectedDate >= disabledDate) {
      startDate = disabledDate;
    } else {
      endDate = disabledDate;
      break;
    }
  }
  if (startDate) {
    startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    currentSelf.rangeMin = generateDate(startDate);
  }
  if (endDate) {
    endDate = new Date(endDate.setDate(endDate.getDate() - 1));
    currentSelf.rangeMax = generateDate(endDate);
  }
};
const resetDisabledDates = () => {
  if (!currentSelf) return;
  currentSelf.rangeMin = currentSelf.settings.range.min;
  currentSelf.rangeMax = currentSelf.settings.range.max;
  if (currentSelf.settings.range.disablePast && /* @__PURE__ */ new Date(`${currentSelf.settings.range.min}T00:00:00`) < currentSelf.date.today) {
    currentSelf.rangeMin = generateDate(currentSelf.date.today);
  }
};
const handlerMultipleRanged = (self) => {
  if (!self || !self.selectedDates) return;
  currentSelf = self;
  if (self.selectedDates[0] && self.selectedDates.length <= 1) {
    self.HTMLElement.addEventListener("mousemove", hoverDaysEvent);
    document.addEventListener("keydown", cancelSelectionDays);
    if (self.settings.range.disableGaps) setDisabledDates();
  } else {
    self.HTMLElement.removeEventListener("mousemove", hoverDaysEvent);
    document.removeEventListener("keydown", cancelSelectionDays);
    if (self.settings.range.disableGaps) resetDisabledDates();
  }
};
export {
  handlerMultipleRanged as default
};
